import { useMemo } from "react";
import { Typography, Button, Alert } from "@mui/material";
import LaunchIcon from '@mui/icons-material/Launch';
import { useTranslations } from "@fenetech/translations";

import { UserPermissionTypes } from "helpers/enums";
import useUserInfo from "helpers/context/User/useUserInfo";
import { useNavigate } from "react-router-dom";

interface IProps {
    isVisible: boolean
}

const SelectCustomerWarningCard: React.FC<IProps> = ({ isVisible }: IProps) => {
    const tm = useTranslations();
    const userInfo = useUserInfo();
    const navigate = useNavigate();

    const noCustomersAlertText = useMemo(() => {
        if (userInfo.HasPermission(UserPermissionTypes.CreateModifyCustomersAndPricing)) {
            return tm.Get("No customers available for quoting. Add a customer in Customer Setup before entering a quote.")
        } else {
            return tm.Get("No customers available for quoting. Contact your system administrator for assistance.")
        }
    }, [userInfo, tm])

    const noCustomersAlertAction = useMemo(() => {
        if (!userInfo.HasPermission(UserPermissionTypes.CreateModifyCustomersAndPricing)) return;

        return <Button color="inherit" variant="outlined" sx={{fontFamily: "inherit", fontWeight: "bold"}} size="small" onClick={() => navigate("/setup/customers")} endIcon={<LaunchIcon />}>
            {tm.Get("Customer Setup")}
        </Button>
    }, [userInfo, navigate, tm]);

    if (!isVisible) return <></>;

    return <>
        <Alert severity="warning" variant="filled" sx={{width: "100%"}} action={noCustomersAlertAction}>
            <Typography fontWeight="bold">
                {noCustomersAlertText}
            </Typography>
        </Alert>
    </>

}

export default SelectCustomerWarningCard;